import { createAction } from '@reduxjs/toolkit';

export const errorAction = createAction('video/errorAction');
export const initAction = createAction('video/initAction');
export const removeTileAction = createAction('video/removeTileAction');
export const resetStateAction = createAction('video/resetStateAction');
export const setCanUnmuteAction = createAction('video/setCanUnmuteAction');
export const setContentTileAction = createAction('video/setContentTileAction');
export const setGuestSpeakerIdAction = createAction('video/setGuestSpeakerIdAction');
export const setLocalTileAction = createAction('video/setLocalTileIdAction');
export const setMutedAction = createAction('video/setMutedAction');
export const setTileAction = createAction('video/setTileAction');
export const startContentShareAction = createAction('video/startContentShareAction');
export const stopContentShareAction = createAction('video/stopContentShareAction');
export const successAction = createAction('video/successAction');
export const toggleCaptionsAction = createAction('video/changeShowCaptions');
export const toggleVideoAction = createAction('video/toggleVideoAction');
export const toggleVideoStatusAction = createAction('video/toggleVideoStatusAction');
